module.exports = __webpack_public_path__ + "img/IT0000105944893.66be96eb.png";